import names from '@/modules/recording/routers/names'
import {ACCOUNTS_INSTANCE, RECORDING_INSTANCE} from "@/helper/consts";
import DetailEvents from "@/modules/recording/page/public/DetailEvents.vue"
import MyEventsList from "@/modules/recording/page/public/myevents/MyEventsList.vue"
import TokenDetail from "@/modules/recording/page/public/myevents/TokenDetail.vue"

export default ([
    {
        path: 'event/:event',
        name: names.PUBLIC.DETAIL,
        component: DetailEvents,
        meta: {
            breadcrumb: 'Категория',
            instances: [
                RECORDING_INSTANCE,
                ACCOUNTS_INSTANCE
            ],
        },
    },
    {
        path: 'records/',
        name: names.PUBLIC.MYEVENTS,
        component: MyEventsList,
        meta: {
            breadcrumb: 'Мои записи',
            requiredAuth: true,
            instances: [
                RECORDING_INSTANCE,
                ACCOUNTS_INSTANCE
            ],
        },
        children:[
            {
                path: ':code',
                name: names.PUBLIC.TOKEN,
                component: TokenDetail,
                meta: {
                    breadcrumb: 'Запись',
                    requiredAuth: false,
                    instances: [
                        RECORDING_INSTANCE,
                    ],
                },
            }
        ]
    },

])
